---
title: Innovation management
slug: us20150234585
type: patent
status: published
featured: true
summary: An innovation management system of networked members, campaigns as calls for ideas, and an ideas module that can attach submissions to a campaign.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2015-08-20"
lastReviewedAt: "2026-10-02"
audiences:
  - business
  - product-developer
themes:
  - innovation-systems
sourceUrl: https://patents.google.com/patent/US20150234585
originalAuthor: Jay van Zyl
sourceRelationship: first-party patent record
rightsStatus: first-party
seoDescription: Patent US20150234585 — innovation management with profiles, campaigns, and ideas.
canonicalPath: /resources/us20150234585
patentNumber: US20150234585
documentHref: /documents/patents/us20150234585-innovation-management.pdf
---

import { PatentPages } from "@/features/publications/PatentPages"

[US20150234585 on Google Patents](https://patents.google.com/patent/US20150234585) · [Download the patent document (PDF)](/documents/patents/us20150234585-innovation-management.pdf)

<PatentPages id="us20150234585" />

An innovation management system with a database of networked members, each associated with a predefined user profile. A user interface receives inputs from a member and displays selected outputs. A campaigns module defines a campaign as a call to networked members to submit ideas for a particular context. An ideas module holds ideas, which can be associated with a predefined campaign.

Networked members with profiles; a campaigns module (a call for ideas in a defined context); an ideas module that can attach submissions to a campaign.
